export const romaneioCriarFormSearchValues = {
    valorBuscaEmbarcador: '',
    valorBuscaDestinatario: '',
    nrCto: '',
    filialOrigem: '',
}